import type { Custodian } from 'models/custodian';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';

export interface ISecondaryCustodianResponse {
  custodians: Custodian[];
}

export function custodiansApiConnector(http$: IHttpClient) {
  return {
    searchCustodians(criteria: string): Observable<Custodian[]> {
      return http$
        .getJSON<ISecondaryCustodianResponse>({
          url: `api/v1/secondary-market/cp-order/custodians/filter`,
          params: {
            criteria,
          },
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(({ payload }) => payload.custodians));
    },
  };
}
